// 원장 호출 — 접수 화면 윗줄 3번째 카드 (「대기 순서 · 환자 정보 · 원장 호출」, 같은 높이). 명세 §1
//  - 머리: 「원장 호출」 + 재실/부재 + [격자/원장 보기] + [전체 화면 ↗](/call, 원장 보기면 /call?view=doctor)
//  - 미응답 deskShowSec 이상이면 카드 테두리 깜빡임(접수 화면 안에서는 데스크 띠 대신) + 데스크 버튼 2개
//  - 게이트(치과·doctorCall 플래그)는 부모(DeskReception)가 한다. 이 컴포넌트를 그리면 구독이 시작된다
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDoctorCall } from './useDoctorCall';
import DoctorCallGrid from './DoctorCallGrid';
import DoctorCallDoctorView from './DoctorCallDoctorView';
import { PresenceChip, DisconnectBand, DeskButtons, overdueText } from './DoctorCallParts';

function DoctorCallCard({ clinicId, boxStyle, headStyle, h2Style, footStyle }) {
    const navigate = useNavigate();
    const dc = useDoctorCall(clinicId, true);
    const [mode, setMode] = useState('grid');   // 'grid' | 'doctor'

    const overdue = dc.deskOverdue;
    const blinkOn = overdue.length > 0 && Math.floor(dc.nowMs / 1000) % 2 === 0;
    const border = overdue.length > 0 ? { borderColor: blinkOn ? '#DC2626' : '#fca5a5', boxShadow: blinkOn ? '0 0 0 2px #DC2626' : 'none' } : null;
    const tab = (on) => ({ border: '1px solid ' + (on ? '#0f6b5c' : '#d9dfdc'), background: on ? '#0f6b5c' : '#fff', color: on ? '#fff' : '#17201d', borderRadius: 7, padding: '3px 10px', fontSize: 12, cursor: 'pointer', fontWeight: 600 });

    return (
        <div style={{ ...boxStyle, ...border }}>
            <div style={headStyle}>
                <h2 style={h2Style}>{'원장 호출'}</h2>
                <PresenceChip present={dc.present} />
                <span style={{ marginLeft: 'auto', display: 'flex', gap: 6, alignItems: 'center' }}>
                    <button type="button" onClick={() => setMode('grid')} style={tab(mode === 'grid')}>{'격자'}</button>
                    <button type="button" onClick={() => setMode('doctor')} style={tab(mode === 'doctor')}>{'원장 보기'}</button>
                    <button type="button" onClick={() => navigate(mode === 'doctor' ? '/call?view=doctor' : '/call')} style={tab(false)} title="진료실 태블릿용 전체 화면">{'전체 화면 ↗'}</button>
                </span>
            </div>
            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '8px 10px', display: 'grid', gap: 8, alignContent: 'start', overscrollBehavior: 'contain' }}>
                {!dc.connected && <DisconnectBand loaded={dc.loaded} />}
                {dc.err && <div style={{ fontSize: 12.5, color: '#8a2020', background: '#fdecec', border: '1px solid #f5cfcf', borderRadius: 7, padding: '7px 10px' }}>{dc.err}</div>}
                {overdue.length > 0 && (
                    <div style={{ background: '#fffbeb', border: '1px solid #f59e0b', borderRadius: 8, padding: '8px 10px', display: 'grid', gap: 6 }}>
                        <div style={{ fontSize: 13, fontWeight: 800, color: '#92400e' }}>{overdueText(overdue, dc.settings, dc.nowMs)}</div>
                        <DeskButtons overdue={overdue} dc={dc} compact />
                    </div>
                )}
                {mode === 'grid'
                    ? <DoctorCallGrid settings={dc.settings} calls={dc.calls} nowMs={dc.nowMs} disabled={!dc.connected} compact onCell={dc.toggleCell} />
                    : <DoctorCallDoctorView settings={dc.settings} calls={dc.calls} present={dc.present} nowMs={dc.nowMs} loaded={dc.loaded} disabled={!dc.connected} onAck={dc.ack} onPresent={dc.setPresent} compact />}
            </div>
            <div style={footStyle}>{mode === 'grid'
                ? '칸을 한 번 누르면 호출, 다시 누르면 꺼집니다. 체어 번호·상황·시각만 남고 환자 이름은 저장하지 않습니다.'
                : '원장실 PC나 원장 휴대폰에서 이 보기를 열어 두면 새 호출에 소리·알림이 옵니다.'}</div>
        </div>
    );
}

export default DoctorCallCard;
